<template>
  <nd-checkbox-group
    v-model="value"
    class="filter-item-checkbox w-full md:w-360px md:max-h-288px scrollbar"
    :options="checkboxOptions"
    :show-mask="true"
  />
</template>

<script setup lang="ts">
import NdCheckboxGroup from '@/components/form/nd-checkbox-group.vue'

import type { SfilterFilterTag } from '@/types/api'

const value = defineModel<number[]>()

const props = withDefaults(
  defineProps<{
    options?: SfilterFilterTag
  }>(),
  {
    options: () => ({
      title: '',
      tags: [],
    }),
  }
)
const checkboxOptions = computed(() => props.options.tags?.map(t => ({ id: t.id, name: t.name })) ?? [])
</script>

<style lang="scss" scoped>
.filter-item-checkbox {
}
</style>
